import type { GetRequestOptions, IFetchService } from "app/services/fetchService";

import type { TechnologiesDescriptionDto } from "../../types/dto";

const TECHNOLOGIES_DESCRIPTION_PATH = "/sales-api/technologies/description";

const createTechnologyApiService = (fetchService: IFetchService) => {
    return {
        fetchDescription(options?: Readonly<GetRequestOptions>): Promise<TechnologiesDescriptionDto> {
            return fetchService.get(TECHNOLOGIES_DESCRIPTION_PATH, undefined, options);
        },
    };
};

export default createTechnologyApiService;
